export default __webpack_public_path__ + "static/media/skills.17c9ca14.png";